var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert("#merchant-modal .logo{text-align:center;margin-top:-15px}#merchant-modal .logo img{width:120px}#merchant-modal .btn-cta{border-width:1px}#merchant-modal .btns>*{display:inline-block;width:175px;margin-right:20px}#merchant-modal .btns>:last-child{margin-right:0}#merchant-modal .btns>*>*{width:100%}#merchant-modal .btns a{padding-left:10px;padding-right:10px}#merchant-modal .email-subscription-form{padding:0;margin-top:30px;background-color:#f6f7f8}#merchant-modal .email-subscription-form img.icon{display:none}#merchant-modal .email-subscription-form form{padding:15px 108px 21px;background-color:transparent}#merchant-modal .email-subscription-form form .wording h4{font-size:1.285714em;color:#333}#merchant-modal .email-subscription-form form .gig-field,#merchant-modal .email-subscription-form form input[type=submit]{margin-top:0;height:4rem}#merchant-modal .email-subscription-form form .gig-field label{top:-2px}#merchant-modal .email-subscription-form form input[type=submit]{padding:.3em 1em;min-width:0;width:120px}#merchant-modal .email-subscription-form form .error-message{margin:10px 0 0}")
;(function(){module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: {
    slug: String,
    name: String,
    title: String,
    cashbackRate: Number,
    logoUrls: {
      type: Object,
      "default": function() {
        return {
          normal: '',
          hires: ''
        };
      }
    },
    clickUrl: String,
    loggedIn: Boolean,
    hasCCookie: Boolean,
    csrfToken: String,
    couponsBaseUrl: String
  },
  computed: {
    logoUrl: function() {
      return this.logoUrls.hires || this.logoUrls.normal;
    },
    loggedInTextKeyAffix: function() {
      if (this.loggedIn) {
        return 'logged_in';
      } else if (!this.loggedIn && this.hasCCookie) {
        return 'not_logged_in_has_c_cookie';
      } else {
        return 'not_logged_in';
      }
    },
    titleText: function() {
      return I18n.t("js.modules.rewards.merchant_modal.title_" + this.loggedInTextKeyAffix);
    },
    promptText: function() {
      return I18n.t("js.modules.rewards.prompt_text." + this.loggedInTextKeyAffix, {
        percent: this.cashbackRate
      });
    }
  },
  methods: {
    click: function() {
      return GIG.Modal.open({
        id: 'merchant-modal'
      });
    }
  },
  components: {
    BucksBackLoginButton: require('./bucks-back-login-button.vue'),
    EmailSubscriptionForm: require('../../../email_subscription/frontend/components/email-subscription-form.vue')
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"bucks-back-merchant-modal-button"},[_c('a',{staticClass:"btn-invert btn-small affiliate-link",attrs:{"href":clickUrl,"title":title,"data-bhw":"MerchantModalTrigger","rel":"nofollow"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();click($event)}}},[_v("\n    "+_s(t('js.modules.rewards.common.shop_online'))+"\n  ")]),_v(" "),_c('div',{staticClass:"modal merchant-modal",attrs:{"id":"merchant-modal","data-bhw":"MerchantModal"}},[_c('div',{staticClass:"modal-body row",attrs:{"data-bhc":'merchant:' + slug}},[_c('a',{staticClass:"close-modal icon-x",attrs:{"data-bhw":"CloseButton"}}),_v(" "),_c('div',{staticClass:"eleven columns centered text-center"},[_c('h2',{staticClass:"title"},[_v(_s(titleText))]),_v(" "),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":logoUrl,"alt":""}})]),_v(" "),_c('div',{staticClass:"cash-back text-center"},[_m(0),_v(" "),_c('p',{class:{ 'bucks-back-total': loggedIn, 'login': !loggedIn }},[_v("\n            "+_s(promptText)+"\n          ")])]),_v(" "),_c('div',{staticClass:"text-center btns"},[_c('bucks-back-login-button',{attrs:{"logged-in":loggedIn,"has-c-cookie":hasCCookie}}),_v(" "),_c('a',{staticClass:"affiliate-direct",class:{ 'btn-cta': loggedIn, 'btn-invert': !loggedIn },attrs:{"href":clickUrl,"target":"_blank","rel":"nofollow"}},[_v("\n            "+_s(t('js.modules.rewards.common.shop_online'))+"\n          ")])],1)]),_v(" "),_c('div',{staticClass:"row"},[_c('email-subscription-form',{attrs:{"url":couponsBaseUrl + '/subscribe',"csrf":csrfToken,"merchant-slug":slug,"merchant-name":name}})],1)])])])}}
__vue__options__.staticRenderFns = [function(){with(this){return _c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-bucks"})])}}]
